import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';

function Tooltip({ className = null, children = null, effect = 'solid', ...otherProps }) {
  const tooltipClass = classNames('ws-tooltip', className);

  return (
    <ReactTooltip className={tooltipClass} effect={effect} {...otherProps}>
      {children}
    </ReactTooltip>
  );
}

Tooltip.hide = () => ReactTooltip.hide();
Tooltip.rebuild = () => ReactTooltip.rebuild();

Tooltip.propTypes = {
  effect: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Tooltip;
